var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114.4 122.88",
    style: {
      enableBackground: "new 0 0 114.4 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DD0031;} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#C3002F;} .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.2,0 57.2,0 57.2,0 0,20.4 8.72,96.03 57.2,122.88 57.2,122.88 57.2,122.88 105.68,96.03 114.4,20.4 57.2,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "57.2,0 57.2,13.64 57.2,13.58 57.2,75.82 57.2,75.82 57.2,122.88 57.2,122.88 105.68,96.03 114.4,20.4 57.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.2,13.58L21.44,93.76l0,0h13.33l0,0l7.19-17.94h30.35l7.19,17.94l0,0h13.33l0,0L57.2,13.58L57.2,13.58 L57.2,13.58L57.2,13.58L57.2,13.58L57.2,13.58z M67.65,64.76H46.76L57.2,39.63L67.65,64.76L67.65,64.76z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.0a1a68b6fcd0e40935c97ace11e7094d.svg";
export { ForwardRef as ReactComponent };